<template>
  <BasicTree
    ref="treeRef"
    v-bind="getBindValue"
    :loading="loading"
    :treeData="treeData"
    @select="handleSelect"
  />
</template>

<script lang="ts" setup>
  import { computed, nextTick, onMounted, ref } from 'vue';
  import { createApi } from '@/api';
  import { BasicTree } from '..';
  import { TreeActionType, treeEmits, TreeItem, treeProps } from './types/tree';
  import { useTreeEvents } from './hepler';

  defineOptions({ name: 'DeptTree' });

  const props = defineProps(treeProps);
  const emit = defineEmits(['select', ...treeEmits]);
  const bindTreeEvents = useTreeEvents(emit);
  const getBindValue = computed(() => {
    return {
      ...props,
      title: props.title || 'c.25110073',
      toolbar: props.toolbar ?? true,
      search: props.search ?? true,
      clickRowToExpand: props.clickRowToExpand ?? false,
      defaultExpandLevel: props.defaultExpandLevel || 1,
      fieldNames: { title: 'name', key: 'id' },
      ...bindTreeEvents,
    };
  });

  const loading = ref(false);
  const treeRef = ref<TreeActionType>();
  const treeData = ref<TreeItem[]>([]);
  onMounted(() => {
    loading.value = true;
    createApi<Recordable, TreeItem[]>('/ims-auth/sysDept/list-tree-all')()
      .then((res) => {
        treeData.value = res;
        nextTick(() => treeRef.value?.filterByLevel(1));
      })
      .finally(() => (loading.value = false));
  });
  const handleSelect = (keys, event) => emit('select', keys[0], event.selectedNodes[0]);
</script>
